import { render } from "./NotificationsPanelDialog.vue?vue&type=template&id=ba33b9f0&scoped=true"
import script from "./NotificationsPanelDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsPanelDialog.vue?vue&type=script&lang=js"

import "./NotificationsPanelDialog.vue?vue&type=style&index=0&id=ba33b9f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba33b9f0"]])

export default __exports__